<template> 
    <div > 
        <div class="crumbs" hidden="true" style="margin-left:10px;" >
            <el-breadcrumb separator="/">
                <el-breadcrumb-item><i class="el-icon-lx-calendar"></i> 商品管理
                </el-breadcrumb-item>
                 <el-breadcrumb-item>添加商品</el-breadcrumb-item>
            </el-breadcrumb>
        </div> 
          <div class="container" v-loading="loading2" element-loading-text="正在保存商品数据" element-loading-spinner="el-icon-loading">  
            <el-collapse accordion style="padding:0px 30px 10px 0px;background-color:#fff; margin-top:-20px">
                <el-collapse-item>
                    <template slot="title">
                        <div  style="font-size:18px;"> <i class="header-icon el-icon-info" style="color:#F56C6C;margin-right:10px;"></i>操作说明</div>
                    </template>
                    <div style="font-size:14px;color:#333;"> <pre>
        1.默认使用落地页模版二，验证码在二确页
        2.分享链接或下载excel时，请提前分配好产品。如未分配，落地页链接及资料页链接将不能查看</pre>

                    </div> 
                </el-collapse-item>
            </el-collapse>
            <div class="handle-box" style="overflow-y:hidden; " >  
                <span class="label-span">
                    <label class="label">系统产品名称</label> 
                    <el-select v-model="query.goodsId" multiple collapse-tags  placeholder="产品名称，可多选" filterable  clearable style="width:350px;" class=" mr10">
                        <el-option value="" label="全部"  />  
                        <el-option v-for="item in select1.option" :key="item.id" :label="item.optVal" :value="item.optKey" /> 
                    </el-select>
                </span>
                <span class="label-span">
                    <label class="label">上游资源名称</label> 
                    <el-select v-model="query.channelCode"  placeholder="资源名称" filterable  clearable class="handle-select mr10">
                        <el-option value="" label="全部"  />  
                        <el-option v-for="item in select6.option" :key="item.id" :label="item.optVal" :value="item.optKey" /> 
                    </el-select>
                </span> 
                <span class="label-span">
                    <label class="label">上游产品名称</label> 
                    <el-input v-model.trim="query.channelGoodsName" placeholder="资源产品名称" style="width:120px;" class="handle-input mr10"></el-input> 
                </span> 
                <span class="label-span">
                    <label class="label">计费通道</label> 
                    <el-select v-model="query.isp"  placeholder="计费通道" filterable  clearable class="handle-select mr10">
                        <el-option value="" label="全部"  />
                        <el-option value="1" label="移动"  /> 
                        <el-option value="2" label="联通"  /> 
                        <el-option value="3" label="电信"  />  
                        <el-option label="自收款" value="0" /> 
                        <el-option label="代收款" value="9" />    
                    </el-select>  
                </span> 
                <span class="label-span">
                    <label class="label">系统产品分类</label> 
                    <el-select v-model="query.goodsType"  placeholder="产品分类" filterable  clearable class="handle-select mr10">
                        <el-option value="" label="全部"  />  
                        <el-option v-for="item in select2.option" :key="item.id" :label="item.optVal" :value="item.optKey" /> 
                    </el-select>
                </span>
                <span class="label-span">
                    <label class="label">系统产品状态</label> 
                    <el-select v-model="query.status"  placeholder="产品状态" filterable  clearable class="handle-select mr10">
                        <el-option value="" label="全部"  />    
                        <el-option value="1" label="已上架"  /> 
                        <el-option value="0" label="已下架"  />     
                    </el-select>
                </span> 
                <span class="label-span">
                    <label class="label">产品推广状态</label> 
                    <el-select v-model="query.promoteStatus"  placeholder="推广状态" filterable  clearable class="handle-select mr10">
                        <el-option value="" label="全部"  />    
                        <el-option value="1" label="推广中"  /> 
                        <el-option value="0" label="已暂停"  />     
                    </el-select>
                </span>  


            <span :hidden="showDiv">  
                <span class="label-span">
                    <label class="label">产品资费</label> 
                    <el-input v-model.trim="query.goodsRate"  oninput="value=value.replace(/[^0-9.]/g,'')" placeholder="小于等于/元" style="width:120px;" class="handle-input mr10"></el-input> 
                </span> 
                <span class="label-span">
                    <label class="label">上游结算类型</label> 
                    <el-select v-model="query.channelComType"  placeholder="结算类型" filterable  clearable class="handle-select mr10">
                        <el-option value="" label="全部"  /> 
                        <el-option value="1" label="CPA"  /> 
                        <el-option value="2" label="CPS"  />  
                    </el-select> 
                </span>    
                <span class="label-span">
                    <label class="label">系统结算类型</label> 
                    <el-select v-model="query.goodsComType"  placeholder="结算类型" filterable  clearable class="handle-select mr10">
                        <el-option value="" label="全部"  /> 
                        <el-option value="1" label="CPA"  /> 
                        <el-option value="2" label="CPS"  />  
                    </el-select> 
                </span>    
            </span>     
            <el-tooltip  :content="showDiv?'展开更多筛选条件':'收起更多筛选条件'" placement="top">
                <el-button type="error"  class="mr10"  @click="showMore"> {{show}} </el-button>
            </el-tooltip>   
                <el-button type="success" icon="el-icon-search" class="mr10"   @click="handleSearch">搜索</el-button>
                <el-button type="error" icon="el-icon-refresh" class="mr15"   @click="refreshSearch">重置</el-button> 
                <el-button type="primary" icon="el-icon-download" class="mr10" @click="downExcel">资料下载</el-button>  
                 
               
            </div>
            <el-table :data="tableData" border modal="true" size="mini"  class="table"  ref="multipleTable" header-cell-class-name="table-header"  @selection-change="handleSelectionChange"
            v-loading="loading"  element-loading-text="正在操作..." element-loading-spinner="el-icon-loading"    >
                <el-table-column prop="masterImg" width="80" align="center" label="产品主图">
                    <template slot-scope="scope" > 
                        <img :src="scope.row.goodsImg" style="width:60px;height:60px;border-radius:5px;" @click="getImgDetail(scope.row.goodsCode)" />  
                         
                    </template>
                </el-table-column> 
                <el-table-column prop="channel" min-width="220" align="left" label="资源信息">
                    <template slot-scope="scope" >
                        <p style="font-size:13px;line-height:18px;color:#777;">
                            计费通道：<el-tag :style="scope.row.isp==1?'background:#409eff;color:#fff;':scope.row.isp==2?'background:#fd7a7a;color:#fff;':scope.row.isp==3?'background:#3f3d3d;color:#fff;':scope.row.isp==0?'background:#2ade6e;color:#fff;':scope.row.isp==9?'background:#ed5fbe;color:#fff;':'background:#999;color:#fff;'">
                                {{scope.row.isp==1?'移动':scope.row.isp==2?'联通':scope.row.isp==3?'电信':scope.row.isp==0?'自收款':scope.row.isp==9?'代收款':'其它'}}
                                </el-tag><br> 
                            资源名称：{{scope.row.channelName}}<br> 
                            商品名称：<span @click="copyLink(scope.row.channelGoodsName,'商品名称')" style="font-size:12px;color:#be9d1d;font-weight:700">{{scope.row.channelGoodsName}}</span> 
                            
                        </p>
                    </template>
                </el-table-column>
                <el-table-column prop="channel" min-width="160" align="left" label="商品资费佣金">
                    <template slot-scope="scope" >
                        <p style="font-size:13px;line-height:18px;color:#777;">
                            商品资费： {{scope.row.goodsRate}} 元 <br>
                            结算类型：  {{scope.row.channelComType==1?'CPA':scope.rowchannelComType==2?'CPS':'其它'}}<br>
                            推广佣金：<el-link type="danger" ><b>￥{{scope.row.channelCom}}<span v-if="scope.row.channelComType==2">X{{scope.row.channelComTimes}}</span> 元</b></el-link><br> 
                        </p>
                    </template>
                </el-table-column>
                <el-table-column prop="channel" min-width="170" align="left" label="商品投放信息">
                    <template slot-scope="scope" >
                        <p style="font-size:13px;line-height:18px;color:#777;">
                            投放年龄： {{scope.row.ageRange}}  <br>
                            冷静时长：  {{scope.row.coolTime}}<br>
                            投放时间：  {{scope.row.promoteStart}}-{{scope.row.promoteEnd}}<br>
                        </p>
                    </template>
                </el-table-column>
                <el-table-column prop="goodsName" min-width="220" align="left" label="系统产品信息">
                    <template slot-scope="scope" >
                        <p style="font-size:13px;line-height:18px;color:#777;">
                            产品分类：{{scope.row.goodsTypeName}}<br>
                            产品编码：<el-link @click="copyLink(scope.row.goodsCode,'产品编码')" style="text-align:center;font-size:12px;"  type="primary"><b>{{scope.row.goodsCode}}</b></el-link><br>
                             
                            产品名称：<span @click="copyLink(scope.row.goodsName,'产品名称')" style="font-size:12px;color:#be9d1d;font-weight:700">{{scope.row.goodsName}}</span> 
                           
                        </p>
                    </template>
                </el-table-column>
                <el-table-column prop="goodsName" min-width="180" align="left" label="产品结算信息">
                    <template slot-scope="scope" >
                        <p style="font-size:14px;line-height:30px;color:#777;"> 
                            结算类型：  {{scope.row.goodsComType==1?'CPA':scope.row.goodsComType==2?'CPS':'其它'}}<br>
                            结算佣金：<el-link type="danger" style=" font-size:13px;"><b>￥{{scope.row.goodsCom}}<span v-if="scope.row.goodsComType==2">X{{scope.row.goodsComTimes}}</span> 元</b></el-link><br>
                        </p>
                    </template>
                </el-table-column> 
                <el-table-column prop="status" width="160" align="center" label="系统产品状态"> 
                    <template slot-scope="scope" >  
                      <p style="font-size:14px;line-height:30px;color:#777;">
                            上架状态：<el-tag :type="scope.row.status=='1'?'primary':'danger'">{{scope.row.status=='1'?'已上架':'已下架'}}</el-tag><br>
                            推广状态：<el-tag :type="scope.row.status=='1'?'primary':'danger'">{{scope.row.promoteStatus=='1'?'推广中':'已暂停'}} </el-tag>
                             
                        </p>
                    </template> 
                </el-table-column>  
                <el-table-column prop="status" width="100" align="center" label="操作" fixed="right"> 
                    <template slot-scope="scope" >  
                    <el-button type="primary" plain @click="getLink1(scope.row.goodsName+'-资料页链接',scope.row.goodsCode)">资料页链接</el-button>  <br> 
                    <el-button type="primary" plain  @click="getLink2(scope.row.goodsName+'-落地页链接',scope.row.goodsCode)" >落地页链接</el-button> 
                    </template> 
                </el-table-column>  
            </el-table>
            <div class="pagination">
                <el-pagination 
                    background
                    layout="total,  sizes,prev, pager, next,jumper"
                    :page-sizes="[10, 20, 50, 200]"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @size-change="handleSizeChange"
                    @current-change="handlePageChange" 
                ></el-pagination>
            </div>
        </div>
       

        <el-dialog :title="name" :modal-append-to-body='false' :visible.sync="moreVisible" top="50px" width="450px"> 
            <div style="max-height:500px;overflow-y:auto">
                <div v-html="text">  </div>
            </div> 
        </el-dialog>

    </div>
 
</template> 

<script>
import $ from 'jquery' ;
import {fetchData,downOrderExcel,fetchSelect as fetchSelect1 } from '../../api/comGoodsDoc';   
import {fetchSelect as fetchSelect2} from '../../api/goodsType';  //产品分类 
import {fetchSelect as fetchSelect6} from '../../view/channel/channel';  //资源名称

import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import Quill from 'quill'
import { quillEditor } from 'vue-quill-editor';
import { ImageDrop } from 'quill-image-drop-module' // 图片拖动组件引用
import ImageResize from 'quill-image-resize-module' // 图片缩放组件引用
Quill.register('modules/imageDrop', ImageDrop) // 注册
Quill.register('modules/imageResize', ImageResize) // 注册 
const toolbarOptions = [
  ["bold", "italic", "underline", "strike"], // 加粗 斜体 下划线 删除线 -----['bold', 'italic', 'underline', 'strike']
  //["blockquote", "code-block"], // 引用  代码块-----['blockquote', 'code-block']
  [{ list: "ordered" }, { list: "bullet" }], // 有序、无序列表-----[{ list: 'ordered' }, { list: 'bullet' }]
  //[{ 'header': 1 }, { 'header': 2 }],
  //[{ script: "sub" }, { script: "super" }], // 上标/下标-----[{ script: 'sub' }, { script: 'super' }]
  //[{ indent: "-1" }, { indent: "+1" }],
  //[{ size: ['small', false, 'large', 'huge']}], // 配置字号
  [{ header: [1, 2, 3, 4, 5, 6, false] }], // 标题-----[{ header: [1, 2, 3, 4, 5, 6, false] }]
  [{ color: [] }, { background: [] }], // 字体颜色、字体背景颜色-----[{ color: [] }, { background: [] }]
  //[{ font: []}], //显示字体选择
  [{ align: [] }], // 对齐方式-----
 // ["clean"], // 清除文本格式-----
  ['link', 'image'],// ['link', 'image', 'video'], // 链接、图片、视频-----
]; 
export default {

    data() {
        return {  
            editorOption: {
                isSubmitting: false, // 是否正在提交
                placeholder: '不超过400个字',
                // 主题
                theme: "snow",
                modules: {
                    imageDrop: true,      //图片拖拽
                    imageResize: {          //放大缩小
                    displayStyles: {
                        backgroundColor: "black",
                        border: "none",
                        color: "white"
                        },
                        modules: ["Resize", "DisplaySize", "Toolbar"]
                    }, 
                    toolbar: toolbarOptions,
                },
            }, 
            fag:'0',
            goodsCode:'',
            Timeout:'', 
            Ishow:'el-icon-caret-bottom',
            widthSet:'450px', 
            topSet:'50px',
            imgUrl:'',
            text:'',
            name:'',
            orderDis:true,
            contentVisible:false,
            saveContent:'0',
            contentVal:'',
            infoVisible:false,
            loading:false,
            loading2:false,
            showDiv:true,
            show:'v',
            loadingTitle:'正在初始化数据',
            cropImg:require('/public/base-img.png'), 
            fileList:[],
            fileList2:[],
            detailImg:[], 
            dialogImageUrl: '',
            dialogVisible: false,
            disabled: false,
            skuVisible:false, 
            moreVisible:false,
            select1:{ option:'',  },  
            select2:{ option:'',  },  
            select3:{ option:'',  }, 
            select4:{ option:'',  },  
            select5:{ option:'',  },  
            select6:{ option:'',  },  
            select7:{ option:'',  },  
            query: { 
                pageIndex: 1,
                pageSize: 10, 
                promoteStatus:'1',
                status:'1',
            }, 
            imgHeight:'600',
            tableData: [],
            skuCodes:[],
            multipleSelection: [],
            delList: [],
            editVisible: false,
            imgVisible:false,
            addVisible:false,
            detailVisible:false,
            pageTotal: 0,
            form: {  
                ids:'',
                names:'',
            },
            form1: {  
                 smsSize:0,
                 goodsComType:'1',
                 channelComType:'1',
            },
            promoteArea:[],
            goodsRead:[],
            goodsTag:[],
            promoteArea2:[],
            goodsRead2:[],
            goodsTag2:[],
            form2:{masterImg:'',fileList:[]},
            form3:{},
            idx: -1,
            id: -1
        };
    },
    components: {
        quillEditor
    },
    created() { 
    },
    //页面加载方法
    mounted: function () { 
        //获取下拉框数据 
        //查询列表
        this.getSelect1();  
        this.getSelect2();   
        this.getSelect6(); 
        this.getData();  
      
    },

    methods: { 
        setEdit(){ 
            if(this.orderDis){
                this.orderDis = false;
            }else{
                this.orderDis = true;
            } 
        },
        numFilter(value) { 
            const realVal = parseFloat(value).toFixed(2); 
            return realVal; 
        }, 
        fullOper(){ 
            if(this.widthSet=='450px'){ 
                this.widthSet="100%";
                this.topSet = "0";
                this.heightSet = "100%"; 
            }else{
                this.widthSet="450px";
                this.topSet = "50px";
                this.heightSet = "60%";
            } 
        }, 
        open(name,content){
            this.text = content;
            this.name = name;
            this.moreVisible = true;
        }, 
        saveText(){
            if(this.saveContent == "0"){
               this.$set(this, 'saveContent','1'); 
               this.$notify({ title: '成功', message: '已成功保存落地页富文本内容',duration: 1000, type: 'success' });
            }else{
               this.$set(this, 'saveContent','0'); 
                this.$notify({ title: '成功', message: '已取消保存落地页富文本内容',duration: 1000, type: 'success' });
            }
           // 
            
        },
        addContent(){
            this.contentVisible = true;
        },
        //主图添加方法
        setImage(e){
            const file = e.target.files[0];  
            if (!file.type.includes('image/')) {
                 this.$message.error("只能上传图片");
                return;
            }
            const reader = new FileReader();
            reader.onload = (event) => { 
                this.cropImg = event.target.result;   
            };
            reader.readAsDataURL(file);     
        },
        //主图修改
        chageImage(e){
            const file = e.target.files[0];  
            if (!file.type.includes('image/')) {
                 this.$message.error("只能上传图片");
                return;
            }
            const reader = new FileReader();
            reader.onload = (event) => { 
                this.form2.masterImg = event.target.result;   
            };
            reader.readAsDataURL(file);  
        },
        //详情图上传成功追加数据 
        handleChange(file,fileList) {  
            const isJPG =file.raw.type === "image/png" || file.raw.type === "image/jpg" || file.raw.type === "image/jpeg";
            const isLt5M = file.size / 1024    < 1024;
            if (!isJPG) {
                this.$message.error("上传图片只能是 jpg、jpeg、png 格式!");
                fileList.splice(-1, 1);//移除错误文件
                return false;
            }
            if (!isLt5M) {
                this.$message.error("上传图片单张大小不能超过 1MB!");
                fileList.splice(-1, 1);
                return false;
            }  
            this.fileList = fileList;	  
            
        }, 
        //删除图片 
        handleRemove(file, fileList) {  
            let a = file.url ;
            let b = this.form1.detailPlain.indexOf(a);
            this.form1.detailPlain.splice(b,1);
            this.dialogImageUrl.splice(b,1); 
        }, 
        handleRemove(file) {   
            let i = this.fileList.indexOf(file);   
            this.fileList.splice(i,1); 
        }, 
        changeWidth(i){
            if(i==1){
                this.imgWidth = this.imgWidth - 50;
            }else{
                this.imgWidth = this.imgWidth + 50;
            } 
        },
        changeHeight(i){
            if(i==1){
                this.imgHeight = this.imgHeight - 50;
            }else{
                this.imgHeight = this.imgHeight + 50;
            } 
        },
        showMore(){
            if(this.showDiv){
                this.show = '>';
                this.showDiv = false;
            }else{
                this.show = 'v';
                this.showDiv = true;
            } 
        },
        //详情图放大
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true; 
        }, 
        handleBig(url) {
            this.dialogImageUrl = url;
            this.dialogVisible = true; 
        },
        //文件上传超过最大数量提示
        overMaxImg(file,fileList){
            this.$message.error("详情图最多只能上传9张"); 
        },

       

        //获取下拉框数据
        getSelect1(){ 
            this.select1 = {};  
            fetchSelect1(this.select1).then(res => {   
                if(res.code=='200'){ 
                    this.$set(this.select1, 'option', res.data);  
                }
            });
        },
        getSelect2(){ 
            this.select2 = {}; 
            fetchSelect2(this.select2).then(res => {   
                if(res.code=='200'){ 
                    this.$set(this.select2, 'option', res.data);  
                }
            });
        }, 
        getSelect6(){ 
            this.select6 = {};  
            fetchSelect6(this.select6).then(res => {   
                if(res.code=='200'){ 
                    this.$set(this.select6, 'option', res.data);  
                }
            });
        }, 

        downExcel(){
            this.loading = true;
            var host = localStorage.getItem(window.location.hostname+'_stationUrl');
            var mid = localStorage.getItem(window.location.hostname+'_mid');
            //var link = "http://"+localStorage.getItem(window.location.hostname+'_indexUrl')+"/h5/templateCode_mid/goodsCode/memCode"; 
            this.query.link1 = "http://"+host+"/h5/cl/code2_2/";
            this.query.link2 = "http://"+host+"/h5/goodsDoc/2/";
            setTimeout( () => {
                this.loading = false;  
                this.getData();
            }, 7000) 
            downOrderExcel(this.query).then(res => {   
                this.loading = false
                if(res.code=='200'){ 
                    this.$notify({ title: '成功', message: '后台下载成功',duration: 1000, type: 'success' });
                }else{
                    this.$notify({ title: '失败', message: '后台下载异常',duration: 1000, type: 'error' });
                }
            });
        },
         
        // 触发搜索按钮 
        handleSearch() {
            if(this.query.goodsId){
                this.query.goodsIds = this.query.goodsId.join();
            }else{
                this.query.goodsIds = "";
            } 
            this.$set(this.query, 'pageIndex', 1);
            this.getData(); 
        },
        
        //查询商品id
        search(channelCode){
            let param = {};
            param.channelCode = channelCode;
            param.mid = this.mid;
            param.stationId = this.stationId;
            getSkuCodes(param).then(res => {   
                if(res.code=='200'){  
                    this.skuCodes = res.data.list;
                    this.skuVisible = true;
                }else{
                    this.$message.error(res.message); 
                }
            });
        },

        //重置按钮
        refreshSearch(){ 
            this.$set(this.query, 'ctype'); 
            this.$set(this.query, 'channelCode' ); 
            this.$set(this.query, 'channelGoodsName'); 
            this.$set(this.query, 'goodsRate');  
            this.$set(this.query, 'isp' );   
            this.$set(this.query, 'goodsName');  
            this.$set(this.query, 'goodsType');  
            this.$set(this.query, 'goodsFrom');  
            this.$set(this.query, 'goodsComType');  
            this.$set(this.query, 'status');  
            this.$set(this.query, 'promoteStatus');  
            this.$set(this.query, 'promoteArea');  
            this.$set(this.query, 'goodsTag');   
            this.$set(this.query, 'promoteAreas');  
            this.$set(this.query, 'goodsTags');   
            this.handleSearch();
        },  

         //刷新
        refresh(){
            history.go(0); 
        },
        getImgDetail(goodsCode){ 
            this.imgUrl = "https://"+localStorage.getItem('ms_indexUrl')+"/hk/imgDetail?st="+this.stationId+"&gc="+goodsCode;
            var height = document.body.scrollHeight; 
            this.imgHeight = height*0.8; 
            this.imgVisible=true;
        },

        //查询
        getData(){
            // 获取列表数据   
            fetchData(this.query).then(res => {  
                if(res.code=='200'){ 
                    this.tableData = res.data.list;
                    this.pageTotal = res.data.pageTotal || 0;  
                }else{
                    this.tableData = []; 
                    this.pageTotal = 0;
                } 
                
            });
        }, 
        getInfoDetail(goodsCode){
            this.imgUrl = "https://"+localStorage.getItem('ms_indexUrl')+"/hk/infoDetail?st="+this.stationId+"&gc="+goodsCode;
            this.infoVisible=true;
        },
         
        //复制
        handleCopy(index, row){
            row.mid = this.mid;
            row.stationId = this.stationId; 
            handleCopy(row).then(res => {
                if(res.code=='200'){
                    this.$message.success(res.message); 
                    this.getData();
                }else{
                    //处理该等级绑定的成员
                    this.$message.error(res.message); 
                } 
            }); 
        },
        //详情
        handDetail(index, row){
            $("#input_box3").html(row.goodsMore);
            //查询商品详情
            let detailParam = {};
            detailParam.stationId = this.stationId;
            detailParam.mid = this.mid;
            detailParam.goodsCode = row.goodsCode;
            backDetailImg(detailParam).then(res => {
                if(res.code=='200'){
                    this.detailImg = res.data; 
                }else{ 
                    this.$message.error(res.message); 
                }  
            });
            this.form3 = row;   
            this.detailVisible = true;   
        },
        // 多选操作
        handleSelectionChange(val) {
            this.multipleSelection = val; 
        },
        // 删除
        handDelete(index, row) { 
            row.stationId = this.stationId;  
            row.mid = this.mid;
           
            // 二次确认删除
            this.$confirm('确定要删除 《 '+row.goodsName+' 》 吗？', '提示', {
                type: 'warning'
            }).then(() => {
                handDelete(row).then(res => {
                    if(res.code=='200'){ 
                        this.$message.success('删除成功'); 
                        this.getData();
                    }else{
                        this.$message.error(res.message); 
                    } 
                });
            }) 
        },
        //批量删除
        changeGrade() {
            const length = this.multipleSelection.length; 
            if(length===0){
                this.$message.error("请勾选要删除的商品");
                return;
            }
            var that = this;
            let param = {};
            let goodsCodes = ''; 
            let goodsNames = ''; 
            let title = ''; 
            let ids = '';
            that.delList = that.delList.concat(that.multipleSelection);
            for (let i = 0; i < length; i++) {
                goodsCodes += that.multipleSelection[i].goodsCode + ','; 
                ids += that.multipleSelection[i].id + ','; 
                goodsNames += that.multipleSelection[i].goodsName + ','; 
                title += that.multipleSelection[i].goodsName + '》,《'; 
            }  
                param.goodsCodes = goodsCodes.substr(0,goodsCodes.length-1);  
                param.ids = ids.substr(0,ids.length-1);  
                param.goodsNames = goodsNames.substr(0,goodsNames.length-1);  
                param.mid = that.mid;
                param.stationId = that.stationId;
                title = title.substr(0,title.length-3); 
            // 二次确认删除
            this.$confirm('确定要删除 《'+title+'》 吗？', '提示', {
                type: 'warning'
            }).then(() => { 
                handDeleteBatch(param).then(res => {
                    if(res.code=='200'){ 
                        that.$message.success(res.message); 
                        that.getData();
                    }else{ 
                        that.$message.error(res.message); 
                    } 
                });
            }) 
           

        }, 
         //上下架
        handleStatus(index,row){  
            if(row.status==0){
                this.loadingTitle = "下架";
            }else if(row.status==1){
                this.loadingTitle = "上架";
            } 
            this.loading = true; 
            changeStatus(row).then(res => {
                this.loading = false;
                if(res.code=='200'){  
                    this.$message.success(this.loadingTitle+"成功"); 
                    this.getData();
                }else{ 
                    this.$message.error(this.loadingTitle+"失败"); 
                }  
            }); 
        },

        getLink2(name,goodsCode){  
            var host = localStorage.getItem(window.location.hostname+'_stationUrl');
            var mid = localStorage.getItem(window.location.hostname+'_mid');
            //var link = "http://"+localStorage.getItem(window.location.hostname+'_indexUrl')+"/h5/templateCode_mid/goodsCode/memCode";
            var link = name+"： http://"+host+"/h5/cl/code2_2/"+goodsCode;
            this.copyLink(name,link);
        },

        getLink1(name,goodsCode){  
            var host = localStorage.getItem(window.location.hostname+'_stationUrl');
            var mid = localStorage.getItem(window.location.hostname+'_mid');
            //var link = "http://"+localStorage.getItem(window.location.hostname+'_indexUrl')+"/h5/templateCode_mid/goodsCode/memCode";
            var link = name+"： http://"+host+"/h5/goodsDoc/2/"+goodsCode;
            this.copyLink(name,link);
        },

        handleProStatus(index,row){  
            if(row.promoteStatus==1){
                this.loadingTitle = "开启推广";
            }else if(row.promoteStatus==0){
                this.loadingTitle = "暂停推广";
            }  
            this.loading = true; 
            changeStatus(row).then(res => {
                this.loading = false;
                if(res.code=='200'){  
                    this.$message.success(this.loadingTitle+"成功"); 
                    this.getData();
                }else{ 
                    this.$message.error(this.loadingTitle+"失败"); 
                }  
            }); 
        },

      

        // 新增商品
        addBind() {   
            this.fileList = [];
            this.getSelect6(this.query.ctype); 
            this.saveContent = "0";
            this.addVisible = true;
        },
        validateNumberInput(input) {
            // 使用正则表达式替换非数字和小数点的字符
            input.value = input.value.replace(/[^0-9.]/g, '');

            // 确保只有一个小数点
            let parts = input.value.split('.');
            if (parts.length > 2) {
                input.value = parts[0] + '.' + parts.slice(1).join('');
            }

            // 确保不以小数点开头
            if (input.value.startsWith('.')) {
                input.value = input.value.substring(1);
            }
        },
       
        //保存新增
        saveForm() {   
            if (this.isSubmitting) return;
            this.isSubmitting = true; // 禁用按钮
            if( !this.form1.channelCode ){
                this.isSubmitting = false;
                this.$message.error("请选择商品资源");
                return;
            }
            if( !this.form1.channelGoodsCode ){
                this.isSubmitting = false;
                this.$message.error("请填写商品编码");
                return;
            }
            if( !this.form1.channelGoodsName ){
                this.isSubmitting = false;
                this.$message.error("请填写商品名称");
                return;
            }  
            if( !this.form1.goodsRate ){
                this.isSubmitting = false;
                this.$message.error("请填写商品资费");
                return;
            } 
            if( !this.form1.channelCom ){
                this.isSubmitting = false;
                this.$message.error("请填写商品佣金");
                return;
            } 
            if( !this.form1.channelComType ){
                this.isSubmitting = false;
                this.$message.error("请选择结佣类型");
                return;
            }   
            if(this.form1.channelComType==2 && !this.form1.channelComTimes ){
                this.isSubmitting = false;
                this.$message.error("请填写返佣月份");
                return;
            } 
            if(!this.form1.goodsType){
                this.isSubmitting = false;
                this.$message.error("请填写产品分类");
                return;
            } 
            if(!this.form1.goodsFrom){
                this.isSubmitting = false;
                this.$message.error("请填写产品来源");
                return;
            } 
            if(!this.form1.goodsName){
                this.isSubmitting = false;
                this.$message.error("请填写产品名称");
                return;
            } 
            if(!this.form1.isp){
                this.isSubmitting = false;
                this.$message.error("请填写计费ISP");
                return;
            } 
            if(!this.form1.goodsComType){
                this.isSubmitting = false;
                this.$message.error("请填写结算类型");
                return;
            } 
            if(!this.form1.goodsCom){
                this.isSubmitting = false;
                this.$message.error("请填写产品佣金");
                return;
            } 
            if(!this.form1.goodsComType){
                this.isSubmitting = false;
                this.$message.error("请填写结算类型");
                return;
            } 
            if(this.form1.goodsComType==2 && !this.form1.goodsComTimes ){
                this.isSubmitting = false;
                this.$message.error("请填写结佣月份");
                return;
            } 
            if(!this.goodsRead){
                this.isSubmitting = false;
                this.$message.error("请填写订购条款");
                return;
            }else{
                this.form1.goodsRead = this.goodsRead.join();
            } 
            if(!this.goodsTag){
                this.isSubmitting = false;
                this.$message.error("请选择产品标签");
                return;
            }else{
                this.form1.goodsTag = this.goodsTag.join();
            } 
            if(this.fileList.length<1){
                this.isSubmitting = false;
                this.$message.error("请上传产品图片");
                return;
            }  
            if(!this.promoteArea){
                this.isSubmitting = false;
                this.$message.error("请选择推广地区");
                return;
            }else{
                this.form1.promoteArea = this.promoteArea.join();
            } 
            if(this.saveContent == "1"){
                this.form1.goodsContent = this.contentVal;
            }
            this.loading = true;  
            this.loadingTitle = "正在保存..."; 
            setTimeout( () => {
                this.loading = false;  
                this.getData();
            }, 7000) 
            this.addVisible = false;  
            saveForm(this.form1).then(res => {
                this.isSubmitting = false; 
                if(res.code=='200'){   
                    //上传产品图片
                    let formData = new FormData();  
                    formData.append("goodsCode",res.data.goodsCode); 
                    formData.append("fileIds","");  
                    for(let j = 0; j < this.fileList.length; j++) {
                        formData.append("files", this.fileList[j].raw,this.fileList[j].name); 
                    }   
                    uploadDetailPlain(formData).then(res => {
                        this.loading = false;   
                        this.refreshSearch();
                        if(res.code=='200'){ 
                            this.$message.success("添加产品成功");  
                        }else{
                            this.addVisible = true;  
                            this.$message.error("产品图片上传失败！请重新编辑上传！"); 
                        }
                    }); 
                }else{
                    this.loading = false;  
                    this.$message.error(res.message); 
                } 
            });
        },
        // 编辑操作
        handleEdit(index, row) {
            let data = {};
            data.goodsCode = row.goodsCode;
            this.saveContent = "0";  
            getGoodsDetail(data).then(res => {
                if(res.code=='200'){ 
                    this.form2 = row; 
                    this.goodsTag2 = res.data.detail.goodsTag.split(",");  
                    this.goodsRead2 = res.data.detail.goodsRead.split(",");  
                    this.promoteArea2 = res.data.detail.promoteArea.split(",");  
                    this.form2.smsSize = res.data.detail.smsSize;  
                    this.form2.sureContent = res.data.detail.sureContent;  
                    this.form2.promoteRequire = res.data.detail.promoteRequire; 
                    this.fileList = res.data.files;  
                    if(res.data.detail.goodsContent){ 
                        this.saveContent = '1';
                        this.contentVal = res.data.detail.goodsContent;  
                    } 
                    this.editVisible = true;
                }else{ 
                    this.$message.error(res.message); 
                } 
            });     
            
        },
        AesIdEdit(index, row){  
            let data = {};
            data.id = row.id;
            data.stationId = this.stationId;
            data.mid = this.mid;  
            data.aesId = row.aesId;
            data.goodsCode = row.goodsCode;
            updateAesId(data).then(res => {
                if(res.code=='200'){ 
                    this.getData();
                    this.$message.success(res.message);  
                }else{ 
                    this.$message.error(res.message); 
                } 
            });   
        },
        // 保存编辑
        saveEdit() {  
            if( !this.form2.channelCode ){
                this.$message.error("请选择商品资源");
                return;
            }
            if( !this.form2.channelGoodsCode ){
                this.$message.error("请填写商品编码");
                return;
            }
            if( !this.form2.channelGoodsName ){
                this.$message.error("请填写商品名称");
                return;
            }  
            if( !this.form2.goodsRate ){
                this.$message.error("请填写商品资费");
                return;
            } 
            if( !this.form2.channelCom ){
                this.$message.error("请填写商品佣金");
                return;
            }  
            if( !this.form2.channelComType ){
                this.$message.error("请选择结佣类型");
                return;
            }   
            if(this.form2.channelComType==2 && !this.form2.channelComTimes ){
                this.$message.error("请填写返佣月份");
                return;
            } 
            if(!this.form2.goodsType){
                this.$message.error("请填写产品分类");
                return;
            } 
            if(!this.form2.goodsFrom){
                this.$message.error("请填写产品来源");
                return;
            } 
            if(!this.form2.goodsName){
                this.$message.error("请填写产品名称");
                return;
            } 
            if(!this.form2.isp){
                this.$message.error("请填写计费ISP");
                return;
            } 
            if(!this.form2.goodsComType){
                this.$message.error("请填写结算类型");
                return;
            } 
            if(!this.form2.goodsCom){
                this.$message.error("请填写产品佣金");
                return;
            } 
            if(!this.form2.goodsComType){
                this.$message.error("请填写结算类型");
                return;
            } 
            if(this.form2.goodsComType==2 && !this.form2.goodsComTimes ){
                this.$message.error("请填写结佣月份");
                return;
            } 
            if(!this.goodsRead){
                this.$message.error("请填写订购条款");
                return;
            }else{
                this.form2.goodsRead = this.goodsRead2.join();
            } 
            if(!this.goodsTag){
                this.$message.error("请选择产品标签");
                return;
            }else{
                this.form2.goodsTag = this.goodsTag2.join();
            } 
            if(this.fileList.length<1){
                this.$message.error("请上传产品图片");
                return;
            }  
            if(!this.promoteArea){
                this.$message.error("请选择推广地区");
                return;
            }else{
                this.form2.promoteArea = this.promoteArea2.join();
            } 
            if(this.saveContent == "1"){
                this.form2.goodsContent = this.contentVal;
            }
            this.loading2 = true; 
            setTimeout( () => {
                this.loading2 = false;  
                this.getData();
            }, 5000)
            changeForm(this.form2).then(res => { 
                if(res.code=='200'){  
                    this.$message.success(res.message); 
                     //上传详情图
                    let formData = new FormData(); 
                    formData.append("goodsCode",this.form2.goodsCode); 
                    var fileIds="";
                    var fag = 0;
                    for(let j = 0; j < this.fileList.length; j++) {
                        if(this.fileList[j].raw){
                            fag = 1;
                            formData.append("files", this.fileList[j].raw,this.fileList[j].name); 
                        }else{
                            fileIds+= "'"+this.fileList[j].fileId+"',"; 
                        } 
                    }  
                    if(fileIds.length>1){fileIds=fileIds.substr(0,fileIds.length-1)}
                    formData.append("fileIds",fileIds);  
                    uploadDetailPlain(formData).then(res => { 
                        this.loading2 = false;
                        this.getData();
                        this.editVisible = false; 
                        if(res.code!='200'){
                            this.$message.error(res.message); 
                        }
                    });   
                     
                }else{
                    this.loading2 = false;
                    this.getData();
                    this.$message.error(res.message); 
                }
            });

           
        },
        copyLink(name,text){  
            var copy = document.createElement("input");
            copy.setAttribute("value", text);
            document.body.appendChild(copy);
            copy.select();
            document.execCommand("copy");
            document.body.removeChild(copy);  
            //提示已复制
            this.$message.success(name+"复制成功");  
        },

        // 分页导航
        handlePageChange(val) { 
            this.$set(this.query, 'pageIndex', val);
            this.getData();
        },
        //分页数量更改导航
        handleSizeChange(val){
            this.$set(this.query, 'pageSize', val);
            this.getData();
        }
    }
};
</script>
<style>

.el-upload-list--picture-card .el-upload-list__item{
    width:80px ;
    height:80px ;
}
.el-upload--picture-card{
    width:80px ;
    height:80px ;
    line-height:80px ;
}

.ql-container{
    min-height:150px; 
  }
.ql-editor{
	height: 150px;
}
.contentHei .ql-editor{
    height: 450px;
}
#input_box{
	height: 100px;
	padding: 0 10px;
	font-size: 12px;
	word-wrap:break-word;/*为了在ie和FF顺利换行，加上word-wrap*/
	overflow-x:hidden;
	overflow-y: auto; /*visible (默认), hidden, scroll, 和auto*/
	outline:none;
    border:1px solid #ddd;
    border-radius:5px;
    line-height: 15px;
}
#input_box2{
	height: 100px;
	padding: 0 10px;
	font-size: 12px;
	word-wrap:break-word;/*为了在ie和FF顺利换行，加上word-wrap*/
	overflow-x:hidden;
	overflow-y: auto; /*visible (默认), hidden, scroll, 和auto*/
	outline:none;
    border:1px solid #ddd;
    border-radius:5px;
    line-height: 15px;
}
#input_box3{
	height: 100px;
	padding: 0 10px;
	font-size: 12px;
	word-wrap:break-word;/*为了在ie和FF顺利换行，加上word-wrap*/
	overflow-x:hidden;
	overflow-y: auto; /*visible (默认), hidden, scroll, 和auto*/
	outline:none;
    border:1px solid #ddd;
    border-radius:5px;
    line-height: 15px;
}
.imgOper{
    margin-top: -45px; 
    font-size: 18px; 
    float: right;
    margin-right: 20px;
}
.imgOper span{
    margin-right:20px;
}
.imgOper i{
    margin-right:10px;
}
    .el-dialog__body{
        padding:10px 20px;
    }
    .el-dialog__footer{
        padding: 0px 20px 20px;
    }
    .overflowy{

    overflow-x: hidden; /* 设置溢出滚动 */
   white-space: nowrap;
   overflow-y: scroll;
   /* 隐藏滚动条 */
   scrollbar-width: none; /* firefox */
   -ms-overflow-style: none; /* IE 10+ */
}
.overflowy::-webkit-scrollbar {
    display: none; /* Chrome Safari */
 
}
</style>
<style scoped> 
.label{
    background: #eee;
    font-size: 14px;
    height: 32px;
    display: inline-block;
    line-height: 33px;
    width:100px;
    text-align:center;
    color: #555;
  }
  .label-span{
      display: inline-block;
      height: 40px;
  }
  .red{
      color:red;
      font-weight: 700;
  }
  .mr10 {
    margin-right: 10px;
    margin-left:0;
}
.mr15 {
    margin-right: 15px;
    margin-left:0;
}
.titleInfo{
    width:100%;
    text-align: center;
    line-height: 30px;
    height: 30px;
    font-size: 14px;
    color:#fff; 
    background:#0094d8;
    margin:-20px 0 10px 0; 
}
.handle-box {
    width:100%;
    margin-bottom: 20px;
    overflow-x:auto;
}

.handle-select {
    margin-bottom:5px;
    width: 120px;
    display: inline-block;
}

.handle-input {
    margin-bottom:5px;
    width: 180px;
    display: inline-block;
}
.handle-del {
    float:right; 
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

/**/
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
@media screen and (max-width:999px){ 
  
 .goodDetails{
        font-size:12px;line-height:15px;height:18px;overflow-y:auto;
    }
    .goodRight{
        display:block;
    }
} 
@media screen and (min-width:999px){ 
    .goodDetails{
        font-size:15px;line-height:20px;height:22px;overflow-y:auto;
    }
    .goodRight{
        position:absolute;
        left:130px;
    }
}

</style>
